import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: theme.spacing(40),
  },
}))

export default useStyles
